import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ParrotfyLogo from '../ParrotfyLogo';

const PrincipalNavbar = ({ children }) => (
  <Navbar bg="light" expand="lg" fixed="top">
    <Navbar.Brand as={Link} to="/">
      <ParrotfyLogo />
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    {children}
  </Navbar>
);

export default PrincipalNavbar;
